<form
  (ngSubmit)="onSubmit()"
  [formGroup]="formGroup">
  <love-it-modal-header
    (close)="closeModal()"
    [title]="editText"></love-it-modal-header>
  <ul
    #nav="ngbNav"
    class="nav nav-tabs card-header-tabs"
    ngbNav>
    <li
      [destroyOnHide]="false"
      ngbNavItem="stammdaten">
      <a
        [invalid]="submitted && formGroup.invalid"
        label="Stammdaten"
        love-it-tab
        ngbNavLink></a>
      <ng-template ngbNavContent>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <label
                  class="required-label"
                  for="name"
                  >Name</label
                >
                <input
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('name')?.errors,
                  }"
                  class="form-control"
                  formControlName="name"
                  id="name"
                  type="text" />
                @if (submitted && formGroup.get("name")?.errors) {
                  <div class="invalid-feedback">
                    @if (formGroup.get("name")?.errors["required"]) {
                      <div>Name ist ein Pflichtfeld.</div>
                    }
                  </div>
                }
              </div>
              @if (CaslAction.Update | permission: EntityTyp.Office) {
                <div class="col-sm-6">
                  <label
                    class="required-label"
                    for="type"
                    >Typ</label
                  >
                  <ng-select
                    [formControl]="formGroup.get('type') | formControl"
                    [items]="officeTypes"
                    bindLabel="display"
                    bindValue="value"
                    [clearable]="false"
                    [searchable]="false"
                    id="type"
                    [ngClass]="{
                      'is-invalid': submitted && formGroup.get('type')?.errors,
                    }"></ng-select>
                  @if (submitted && formGroup.get("type")?.errors) {
                    <div class="invalid-feedback">
                      @if (formGroup.get("type")?.errors["required"]) {
                        <div>Typ ist ein Pflichtfeld.</div>
                      }
                    </div>
                  }
                </div>
              }
              @if(formGroup.get('type').value === OfficeType.umF){
                <div class="col-sm-6">
                  <label
                    for="mandatoryReportsPerDay"
                  >
                    Berichte pro Tag
                    <div ngbTooltip="Leitung wird informiert, wenn weniger Bericht an einem Tag verfasst wurden" class="d-inline-flex default-cursor">
                      <love-it-generic-icon selector="info" />
                    </div>
                  </label>
                  <input
                    [ngClass]="{
                      'is-invalid': submitted && formGroup.get('email')?.errors,
                    }"
                    class="form-control"
                    formControlName="mandatoryReportsPerDay"
                    id="mandatoryReportsPerDay"
                    type="number" />
                </div>
              }
            </div>
          </div>
        </div>
      </ng-template>
    </li>
  </ul>
  <div class="modal-body">
    <div
      [ngbNavOutlet]="nav"
      class="mt-2"></div>
  </div>
  <div class="modal-footer">
    <love-it-modal-buttons
      (onSubmit)="onSubmit($event)"
      [dirty]="formGroup.dirty"
      [showSpeichernButton]="CaslAction.Update | permission: EntityTyp.Office"></love-it-modal-buttons>
  </div>
</form>
